import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * Стандартный fetch с AbortSignal и отменой при unmount / смене key.
 * key сериализуется (массив/объект сравниваются по значению), иначе новый `['x', page]`
 * на каждом рендере зацикливал запросы.
 */
export function useAsyncData(key, fetcher, options = {}) {
    const { enabled = true } = options;
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState(null);
    const [tick, setTick] = useState(0);
    const fetcherRef = useRef(fetcher);
    fetcherRef.current = fetcher;
    const serializedKey = serializeAsyncKey(key);
    const refetch = useCallback(() => {
        setTick((t) => t + 1);
    }, []);
    useEffect(() => {
        if (!enabled) {
            setLoading(false);
            return;
        }
        const controller = new AbortController();
        setLoading(true);
        setError(null);
        fetcherRef
            .current(controller.signal)
            .then((result) => {
            if (!controller.signal.aborted) {
                setData(result);
                setLoading(false);
            }
        })
            .catch((err) => {
            if (!controller.signal.aborted) {
                setError(err);
                setLoading(false);
            }
        });
        return () => controller.abort();
    }, [enabled, serializedKey, tick]);
    return { data, loading, error, refetch };
}
function serializeAsyncKey(key) {
    if (typeof key === 'string')
        return key;
    if (typeof key === 'number' || typeof key === 'boolean' || key == null)
        return String(key);
    try {
        return JSON.stringify(key);
    }
    catch {
        return String(key);
    }
}
